import styled from "styled-components";

export const Resource = styled.div`
  background-color: whitesmoke;
  color: rgba(0, 0, 0, 0.726);
  border: 1px solid transparent;
  text-align: center;
  /* padding: 15px; */
  font-size: 12px;

  a{
    &:hover{
      filter: brightness(0.8);
      
    }
        display: block;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        overflow: hidden;          /* Hide any overflowing content */
        font-weight: 600;
        height: 100%;
        border-radius: 4px;
        font-size: 12px;
        line-height: 15.5px;
        

        border: ${({ status }) =>
    status === "doneLate" ? "2px solid #D93333" : "2px solid transparent"};

        background-color: ${({ status }) =>
    status === "done"
      ? "#49B446"
      : status === "late"
        ? "#D93333"
        : status === "doing"
          ? "#EACB29"
          : status === "pending"
            ? "#D4D6DA"
            : "#49b446"};

          color: ${({ status }) =>

    status === "pending" || status === 'doing' ? "#212326"
      : status === "done" || status === 'doneLate'
        ? "#EFF1F5"
        : "#EFF1F5"
  };


      }

`;

export const Period = styled.div`
  position: relative;
  background-color: whitesmoke;
  color: rgba(0, 0, 0, 0.726);
  border: 1px solid transparent;
  text-align: center;
  font-size: 12px;


`;

export const MonthLabel = styled.span`
  display: block;
  background-color: red;
  align-self: end;
  width: 80px;
  max-width: 140px;
  max-height: 30px;
  //padding: 5.65px 13.91px 5.42px 11.3px;
  padding: 5px 10px;
  font-size: 12px;
  margin: 0;

  background: ${({ isActualMonth }) => (isActualMonth ? "#40E5A0" : "#d4d6da")};
  color: #212326;
  font-weight: 600;
  border-radius: 8px;
`;

export const Container = styled.div`
  position: absolute;
  background-color: #40e5a0;
  top: -10px;
  border-radius: 4.25px;
  width: 40px;
  height: 20px;
  //left: -20px; //Intervalo entre -20px a 20px
  z-index: 50;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;

  &:after {
    content: "";

    display: block;
    position: absolute;
    bottom: -7px;
    left: calc(50% - 6.328px);

    border-left: 6.328px solid transparent;
    border-right: 6.328px solid transparent;
    border-top: 9.328px solid #40e5a0;
  }
  span {
    font-size: 11.3px;
    display: block;
    font-weight: 600;
  }

  div {
    position: absolute;
    width: 2.5px;
    top: 40px;
    background-color: #7e858f;
  }
`;
